import { Input } from 'src/lib/constants';

export type AllInputs = {
  [Input.AirlineChoice]: AirlineChoice | AirlineChoice[];
  [Input.AnnualFees]: boolean;
  [Input.CardDeposit]: boolean;
  [Input.CollegeStudent]: boolean;
  [Input.CreditScore]: CreditScore;
  [Input.CurrentBalanceCompany]: CurrentBalanceCompany;
  [Input.FullDebt]: FullDebt[];
  [Input.HotelChoice]: HotelChoice | HotelChoice[];
  [Input.HowLongToPayOffDebt]: HowLongToPayOffDebt;
  [Input.InternationalTravel]: boolean;
  [Input.IsBuildingCredit]: boolean;
  [Input.IsDebtCreditCard]: boolean;
  [Input.MonthlySpend]: number;
  [Input.LuxuryPerks]: LuxuryPerks[];
  [Input.PrimaryGoal]: PrimaryGoal;
  [Input.RewardsAndPerks]: RewardsAndPerks;
  [Input.SpecificAirlineOrHotel]: SpecificAirlineOrHotelValues;
  [Input.SecurityDeposit]: number;
  [Input.SpendingCategories]: SpendingCategories[];
  [Input.CashBackBigPurchase]: CashBackBigPurchase;
  [Input.CashBackPreference]: CashBackPreference;
  [Input.ManagingCategories]: ManagingCategories;
  [Input.IntroAPROrRewards]: IntroAPROrRewards;
  [Input.PurchaseSpend]: number;
  [Input.TypeOfDebt]: TypeOfDebt;
  [Input.StudentSpendingCategories]: StudentSpendingCategories[];
  [Input.PurchaseSpendingCategories]: PurchaseSpendingCategories[];
};

export type FullDebt = {
  debtType: DebtTypeEnum;
  institution: CurrentBalanceCompany;
  amount: number;
};

export enum SpecificAirlineOrHotelValues {
  YesHotel = 'YES_HOTEL',
  YesAirline = 'YES_AIRLINE',
  YesBoth = 'YES_BOTH',
  Neither = 'NEITHER',
}

export enum PrimaryGoal {
  BigPurchase = 'BIG_PURCHASE',
  BuildCredit = 'BUILD_CREDIT',
  CashBack = 'CASH_BACK',
  Debt = 'DEBT',
  Travel = 'TRAVEL',
}

export enum AirlineChoice {
  AerLingus = 'AER_LINGUS',
  Aeroplan = 'AEROPLAN',
  AlaskaAirlines = 'ALASKA_AIRLINES',
  AmericanAirlines = 'AMERICAN_AIRLINES',
  BritishAirways = 'BRITISH_AIRWAYS',
  Delta = 'DELTA',
  Jetblue = 'JETBLUE',
  Iberia = 'IBERIA',
  Other = 'OTHER',
  SouthwestAirlines = 'SOUTHWEST_AIRLINES',
  UnitedAirlines = 'UNITED_AIRLINES',
}

export enum SpendingCategories {
  DrugStores = 'DRUG_STORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL',
}

export enum CashBackPreference {
  Categories = 'CATEGORIES',
  SameRate = 'SAME_RATE',
}

export enum CreditScore {
  Average = 'AVERAGE',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Poor = 'POOR',
  LimitedCreditHistory = 'LIMITED_CREDIT_HISTORY',
}

export enum CurrentBalanceCompany {
  AmericanExpress = 'AMERICAN_EXPRESS',
  BankOfAmerica = 'BANK_OF_AMERICA',
  CapitalOne = 'CAPITAL_ONE',
  Chase = 'CHASE',
  Citibank = 'CITIBANK',
  Discover = 'DISCOVER',
  Other = 'OTHER',
  UsBank = 'US_BANK',
  WellsFargo = 'WELLS_FARGO',
}

export enum HotelChoice {
  Choice = 'CHOICE',
  Hilton = 'HILTON',
  Hyatt = 'HYATT',
  Ihg = 'IHG',
  Marriott = 'MARRIOTT',
  Other = 'OTHER',
  Radisson = 'RADISSON',
  Wyndham = 'WYNDHAM',
}

export enum HowLongToPayOffDebt {
  LessThan18Months = 'LESS_THAN_18_MONTHS',
  MoreThan18Months = 'MORE_THAN_18_MONTHS',
}

export enum LuxuryPerks {
  HasAirportLoungeAccess = 'has-airport-lounge-access',
  HasExpeditedSecurity = 'has-expedited-security',
  HasTravelCredits = 'has-travel-credits',
  HasPrimaryRentalCarInsurance = 'has-primary-rental-car-insurance',
  HasFreeCheckedBags = 'has-free-checked-bags',
  HasCompanionFareAnnualFlight = 'has-companion-fare-annual-flight',
  HasFreeAnnualHotelNight = 'has-free-annual-hotel-night',
  HasGlobalEntryTsaCredit = 'has-globalentry-tsa-credit',
  HasAutomaticEliteStatus = 'has-automatic-elite-status',
}

export enum RewardsAndPerks {
  HasEarningRewardsRedeemedForTravelExpenses = 'HAS_EARNING_REWARDS_REDEEMED_FOR_TRAVEL_EXPENSES',
  HasLuxuryPerksTravelPleasant = 'HAS_LUXURY_PERKS_TRAVEL_MORE_PLEASANT',
  HasMixRewardsAndTravelPerks = 'HAS_MIXED_REWARDS_AND_TRAVEL_PERKS',
}

export enum CashBackBigPurchase {
  No = 'NO',
  Yes = 'YES',
}

export enum ManagingCategories {
  StaticCategories = 'STATIC_CATEGORIES',
  DynamicCategories = 'DYNAMIC_CATEGORIES',
}

export enum IntroAPROrRewards {
  IntroAPR = 'INTRO_APR',
  Rewards = 'REWARDS',
}

export enum TypeOfDebt {
  PersonalLoan = 'PERSONAL_LOAN',
  AutoLoan = 'AUTO_LOAN',
  StudentLoan = 'STUDENT_LOAN',
  HomeEquityLoan = 'HOME_EQUITY_LOAN',
}

export enum StudentSpendingCategories {
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL',
}

export enum PurchaseSpendingCategories {
  HomeImprovement = 'HOME_IMPROVEMENT',
  Travel = 'TRAVEL',
  OnlineShopping = 'ONLINE_SHOPPING',
  Entertainment = 'ENTERTAINMENT',
  Other = 'OTHER',
}

export enum DebtTypeEnum {
  CreditCard = 'CREDIT_CARD',
  PersonalLoan = 'PERSONAL_LOAN',
  AutoLoan = 'AUTO_LOAN',
  StudentLoan = 'STUDENT_LOAN',
  HomeEquityLoan = 'HOME_EQUITY_LOAN',
}
